import ReactMarkdown from 'react-markdown';
import type { Options, Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { cx } from '@/utils/cx';

import { CodeBlock } from '@/components/codeblock/CodeBlock';

type MarkdownProps = Options & {
    markdownContianerClass?: string;
    className?: string;
};

const defaultRemarkPlugins = [remarkGfm];
const defaultComponents: Components = {
    code: CodeBlock,
};

const Markdown = ({
    // this is the class used to scope the css from varnish-theme
    // this should only be changed if you are opting out of the default varnish-theme markdown styling
    markdownContianerClass = 'varnish-markdown',
    className,
    children,
    components = defaultComponents,
    remarkPlugins = defaultRemarkPlugins,
    ...rest
}: MarkdownProps) => {
    return (
        /* Latest version of react-markdown does not support className anymore */
        <div className={cx(markdownContianerClass, className)}>
            <ReactMarkdown components={components} remarkPlugins={remarkPlugins} {...rest}>
                {children}
            </ReactMarkdown>
        </div>
    );
};

export { defaultComponents, defaultRemarkPlugins, Markdown, Markdown as default };
export type { MarkdownProps };
